export default "__VITE_ASSET__DtiRryFP__"